import React from 'react';
import styles from './HelpPanelTips.module.css';
import { useTranslation } from '@hooks/index';

type Props = {
  /** Whether the search box is visible */
  isSearchVisible: boolean;
  /** Current search result index (0-based) */
  currentSearchIndex: number;
  /** Total number of search results */
  totalSearchResults: number;
}

const HelpPanelTips: React.FC<Props> = ({
  isSearchVisible,
  totalSearchResults
}) => {
  const t = useTranslation('ServiceHelpPanel');

  const getTipText = () => {
    if (isSearchVisible && totalSearchResults > 0) {
      return t('Search.TipNavigation');
    } else if (isSearchVisible) {
      return t('Search.TipWhenVisible');
    } else {
      return t('Search.TipWhenHidden');
    }
  };

  return (
    <div className={styles.TipsContainer}>
      <span className={styles.TipText}>
        {getTipText()}
      </span>
    </div>
  );
};

export default HelpPanelTips;
